export const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  drawer: true,
  user: null,
  isError: false,
  errorMessage: null
};
